import { Button } from "./button";

interface NoPaymentMethodCardProps {
    onAddPaymentMethod?: () => void;
}

export const NoPaymentMethodCard: React.FC<NoPaymentMethodCardProps> = ({
    onAddPaymentMethod
}) => (
    <div className="bg-neutral-50 border border-neutral-100 rounded-xl pl-6 pr-4 py-4 flex items-center justify-between">
        <span className="text-xs leading-4 font-normal text-neutral-800 font-mono">
            No Payment Method
        </span>
        {onAddPaymentMethod && (
            <Button
                variant="primary"
                size="sm"
                onClick={onAddPaymentMethod}
                aria-label="Add Payment Method"
            >
                <span className="md:hidden">Add</span>
                <span className="hidden md:inline">Add Payment Method</span>
            </Button>
        )}
    </div>
);
